<template>
  <div class="entrega99-cancel">
    <div class="s-card" style="margin: 5px 2px">
      <select v-model="selected" style="width: 100%; margin-top: 10px;">
        <option value="">Selecione...</option>
        <option v-for="m in motivos" :key="m.codigo" :value="m.codigo">
          {{ m.texto }}
        </option>
      </select>
    </div>
    <div id="footer" style="text-align: right">
      <button @click="$emit('cancel')">Cancelar</button>
      <button class="btn-primary" @click="confirmar">Confirmar</button>
    </div>
  </div>
</template>

<script>
import MOTIVOS_CANCELAMENTO from "./motivosCancelamento";

export default {
  name: "SEntrega99Cancel",
  props: {
    motivos: {
      type: Array,
      default: () => MOTIVOS_CANCELAMENTO,
    },
  },
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    confirmar() {
      if (!this.selected) {
        Notify.warning("Selecione o motivo do cancelamento.");
        return;
      }
      this.$emit("save", this.selected);
    },
  },
};
</script>

<style scoped>
.entrega99-cancel select {
  min-width: 200px;
}
</style>